// extracted by mini-css-extract-plugin
export var active = "_jc-2";
export var recordingDot = "_jc-1";
export var recordingIndicator = "_jc-0";